import PropTypes from "prop-types";
import { MessageSquarePlus } from "lucide-react";
import LoadingSpinner from "../Common/LoadingSpinner";

function AskAiConversationList({ conversations, activeConversationId, loading, onSelect, onNew }) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border p-3">
        <button
          type="button"
          onClick={onNew}
          className="flex w-full items-center justify-center gap-2 rounded-lg border border-accent/40 bg-accent/10 px-3 py-2 text-sm font-medium text-accent transition hover:bg-accent/20 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-surface-raised"
        >
          <MessageSquarePlus size={16} aria-hidden="true" />
          New conversation
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {loading && <LoadingSpinner />}
        {!loading && conversations.length === 0 && (
          <p className="px-4 py-6 text-center text-sm text-text-muted">No conversations yet.</p>
        )}
        <ul>
          {conversations.map((conversation) => (
            <li key={conversation.conversation_id}>
              <button
                type="button"
                onClick={() => onSelect(conversation.conversation_id)}
                aria-current={conversation.conversation_id === activeConversationId ? "true" : undefined}
                className={`w-full truncate px-4 py-2.5 text-left text-sm transition focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent ${
                  conversation.conversation_id === activeConversationId
                    ? "bg-accent/10 font-medium text-accent"
                    : "text-text-secondary hover:bg-surface-sunken"
                }`}
              >
                {conversation.title || "Untitled conversation"}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

AskAiConversationList.propTypes = {
  conversations: PropTypes.arrayOf(
    PropTypes.shape({
      conversation_id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
  activeConversationId: PropTypes.string,
  loading: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
};

AskAiConversationList.defaultProps = {
  activeConversationId: null,
  loading: false,
};

export default AskAiConversationList;
